import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import LinkIcon from '@mui/icons-material/Link';
import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import ReferencialContext, { setReferencial } from 'Shared/ReferencialContext';
import { SALES_CONDITIONS } from '../constants';
import {
  defaultMessage,
  unlinkProductSettings,
  updateProductSettings,
} from '../ProductSettingsServices';
import RelatedProduct from './RelatedProduct';
import LinkedProductAction from './RelatedProduct/LinkedProductAction';

const Setting = () => {
  const { state: product } = useLocation();
  const [productLook, setProductLook] = useState(product);
  const [open, setOpen] = useState();
  const [selectedProduct, setSelectedProduct] = useState();
  const [linkedReference, setLinkedReference] = useState(null);
  const history = useHistory();
  const {
    dispatch,
    state: { referencial },
  } = useContext(ReferencialContext);
  const [values, setValues] = useState({
    reference: productLook?.reference,
    quantityLimit: productLook?.quantityLimit,
    salesCondition: productLook?.salesCondition,
    gameQuantity: productLook?.gameQuantity,
  });
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };
  useEffect(() => {
    setSelectedProduct(referencial.products?.find((p) => p.reference === productLook?.reference));
  }, [referencial.products, productLook]);

  useEffect(() => {
    if (!productLook?.linkedReference || referencial.products?.length === 0) {
      setLinkedReference(null);
      return;
    }
    setLinkedReference(referencial.products
      ?.find((p) => p.reference === productLook?.linkedReference));
  }, [referencial.products, productLook?.linkedReference]);

  const updateSettings = useCallback(async () => {
    setLoading(true);
    try {
      await updateProductSettings({ reference: productLook.reference, ...values });
      toast.success('Les paramétres ont été bien enregistrés');
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setLoading(false);
      history.push('/products-settings');
    }
  }, [values, setLoading]);
  const unlinkProduct = async () => {
    setLoading(true);
    try {
      await unlinkProductSettings(productLook?.reference);
      productLook.linkedReference = null;
      toast.success('la liason à été bien supprimée');
      const { products } = referencial;
      const altredProducts = products.map((p) => {
        const pr = { ...p };
        if (p.reference === productLook?.reference) {
          return { ...pr, linkedReference: null };
        }
        return pr;
      });
      dispatch(setReferencial({ ...referencial, products: altredProducts }));
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setLoading(false);
    }
  };

  const linkCallBack = (refLink) => {
    setProductLook((prev) => ({ ...prev, linkedReference: refLink }));
  };

  return (
    <Box sx={{ margin: '20px 30px' }}>
      {loading && <GlobalLoader size="100vh" />}
      {open && (
        <RelatedProduct
          handleClose={handleClose}
          reference={productLook?.reference}
          linkedReference={selectedProduct?.linkedReference}
          callback={linkCallBack}
        />
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography sx={{
            font: 'normal normal 600 32px Montserrat',
            color: '#000000',
          }}
          >
            Paramètres du produit:
            {productLook?.reference}
          </Typography>
          <Typography sx={{
            font: 'normal normal 500 20px Montserrat',
            color: '#007BC6',
            textTransform: 'capitalize',
          }}
          >
            {productLook?.des}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row-reverse', gap: '10px' }}>
          <Button
            variant="contained"
            sx={{
              borderRadius: '12px',
            }}
            onClick={updateSettings}
            endIcon={<SaveOutlinedIcon />}
          >
            ENREGISTRER
          </Button>
          <Button
            variant="contained"
            sx={{
              background: '#FFFFFF !important',
              borderRadius: '12px',
              fontWeight: 'bold',
              color: '#38485C',
            }}
            onClick={() => history.push('/products-settings')}
          >
            ANNULER
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Paper sx={{
            padding: '25px',
            backgroundColor: '#E9EBED',
            borderRadius: '12px',
          }}
          >
            <TextField
              name="quantityLimit"
              value={values.quantityLimit}
              label="La quantité limite"
              variant="outlined"
              onChange={handleChange}
              fullWidth
              size="small"
              type="number"
              inputProps={{ min: 0 }}
              sx={{
                backgroundColor: '#FFFFFF', mb: 2, borderRadius: '6px',
              }}
            />
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              sx={{
                backgroundColor: '#FFFFFF', mb: 2, borderRadius: '6px',
              }}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                le conditionnement de vente de produit
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={values.salesCondition}
                onChange={handleChange}
                label="le conditionnement de vente de produit"
                name="salesCondition"
              >
                <MenuItem value={null}>
                  <em>None</em>
                </MenuItem>
                {SALES_CONDITIONS.map((s) => (
                  <MenuItem value={s.value}>{s.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {values.salesCondition === 'GAME' && (
              <TextField
                name="gameQuantity"
                value={values.gameQuantity}
                label="quantité du jeu"
                variant="outlined"
                onChange={handleChange}
                fullWidth
                size="small"
                type="number"
                inputProps={{ min: 0 }}
                sx={{
                  backgroundColor: '#FFFFFF', borderRadius: '6px',
                }}
              />
            )}
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Typography
            sx={{
              font: 'normal normal 500 20px Montserrat',
              color: '#000000',
              textTransform: 'capitalize',
              mb: '27px',
            }}
          >
            Produit lié :
          </Typography>

          {linkedReference
            ? (
              <LinkedProductAction
                linkedProduct={linkedReference}
                unlinkProduct={unlinkProduct}
              />
            )
            : (
              <Button
                variant="contained"
                onClick={handleOpen}
                style={{
                  boxShadow: '0px 4px 10px #108CD650',
                  borderRadius: '12px',
                  font: 'normal normal 600 12px Montserrat',
                  color: '#FFFFFF',
                  padding: '8px 15px',
                }}
                startIcon={<LinkIcon />}
              >
                Produit lié
              </Button>
            )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Setting;
